import { useEffect } from "react";
import { useNavigate } from "react-router";

import { setNavigator } from "../../services/navigation.service";


/**
 * Load navigate into navigator service, needs to be called on route level components to allow programmatic navigation
 * useNavigates navigate function is hoisted to global scope by this hook so can navigateTo can be called anywhere
 * in the app
 */

const useNavigatorSetup = () => {
    const navigate = useNavigate();
    
    useEffect(() => {
        setNavigator(navigate);
    }, [navigate]);
}

export default useNavigatorSetup